import { Alert } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import LightbulbCircleOutlinedIcon from "@mui/icons-material/LightbulbCircleOutlined";
import PendingOutlinedIcon from "@mui/icons-material/PendingOutlined";

interface Props {
  status: string;
}

export const StatusBadge = ({ status }: Props) => {
  const normalized = status?.toLowerCase();

  if (normalized === "publish") {
    return (
      <Alert
        icon={
          <CheckCircleOutlineIcon
            sx={{ color: "#1E4620", fontSize: "16px" }}
            fontSize="inherit"
          />
        }
        sx={{
          color: "#1E4620",
          padding: "0px 4px",
          border: "1px solid #2E7D3280",
          display: "flex",
          alignItems: "center",
          textTransform: "capitalize",
          height: "26px",
          width: "93px",
        }}
      >
        {status}
      </Alert>
    );
  }

  if (normalized === "draft") {
    return (
      <Alert
        icon={
          <LightbulbCircleOutlinedIcon
            sx={{ color: "#00000099", fontSize: "16px" }}
            fontSize="small"
          />
        }
        sx={{
          color: "#00000099",
          padding: "0px 4px",
          border: "1px solid #9E9E9E",
          background: "#E0E0E0",
          display: "flex",
          alignItems: "center",
          textTransform: "capitalize",
          height: "25px",
          width: "93px",
        }}
      >
        {status}
      </Alert>
    );
  }
  return (
    <>
      <Alert
        icon={
          <PendingOutlinedIcon
            sx={{ color: "#014361", fontSize: "16px" }}
            fontSize="inherit"
          />
        }
        sx={{
          color: "#014361",
          padding: "0px 4px",
          border: "1px solid #2196F380",
          background: "#E5F6FD",
          display: "flex",
          alignItems: "center",
          textTransform: "capitalize",
          height: "25px",
          width: "93px",
        }}
      >
        {status}
      </Alert>
    </>
  )
}

